import { render, staticRenderFns } from "./add.vue?vue&type=template&id=62fd9b34&scoped=true&"
import script from "./add.vue?vue&type=script&lang=ts&"
export * from "./add.vue?vue&type=script&lang=ts&"
import style0 from "./add.vue?vue&type=style&index=0&id=62fd9b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fd9b34",
  null
  
)

export default component.exports